export default __webpack_public_path__ + "static/media/van-1.43183797.png";